const norm = (y) =>
  y == null || y === ""
    ? ""
    : typeof y === "number" && Number.isFinite(y)
      ? String(y)
      : String(y).trim();

const listArray = (r) => {
  const d = r?.data?.data;
  for (const x of [d, d?.data, d?.rows, r?.data]) if (Array.isArray(x)) return x;
  return null;
};

export const pickReportingYearFromListResponse = (response, reportId) => {
  const row = listArray(response)?.find(
    (item) => String(item?._id) === String(reportId),
  );
  return norm(row?.year);
};

export const extractReportingYearFromBrsrGetResponse = (res) => {
  const d = res?.data?.data ?? res?.data ?? {};
  for (const y of [d.year, d.financialYear, d.reportingYear, res?.data?.year]) {
    const s = norm(y);
    if (s) return s;
  }
  return "";
};

/** List-only year (for parallel fetch with section GET). */
export const fetchYearFromBrsrList = async (get, id) => {
  try {
    return pickReportingYearFromListResponse(
      await get(`/brsr/get/list?page=1&limit=200`),
      id,
    );
  } catch {
    return "";
  }
};

const normFY = (s) =>
  String(s ?? "")
    .trim()
    .replace(/[\u2013\u2014\u2212]/g, "-")
    .replace(/\s*-\s*/g, "-")
    .trim();

export const getFinancialYearLabels = (financialYear) => {
  const raw = normFY(financialYear);
  if (!raw) return { currentYear: "", previousYear: "" };

  const y4y4 = raw.match(/^(\d{4})-(\d{4})$/);
  if (y4y4) {
    const a = +y4y4[1],
      b = +y4y4[2];
    return { currentYear: raw, previousYear: `${a - 1}-${b - 1}` };
  }

  const y4y2 = raw.match(/^(\d{4})-(\d{2})$/);
  if (y4y2) {
    const start = +y4y2[1],
      yy = +y4y2[2];
    let end = Math.floor(start / 100) * 100 + yy;
    if (end <= start) end += 100;
    return {
      currentYear: raw,
      previousYear: `${start - 1}-${String(end - 1).slice(-2)}`,
    };
  }

  if (/^\d{4}$/.test(raw)) {
    const y = +raw;
    return { currentYear: raw, previousYear: String(y - 1) };
  }

  const loose = raw.match(/(\d{4})-(\d{2,4})/);
  if (loose) {
    const a = +loose[1],
      sec = loose[2];
    let end =
      sec.length === 4 ? +sec : Math.floor(a / 100) * 100 + +sec;
    if (end <= a) end += 100;
    return sec.length === 4
      ? {
          currentYear: `${a}-${end}`,
          previousYear: `${a - 1}-${end - 1}`,
        }
      : {
          currentYear: `${a}-${String(end).slice(-2)}`,
          previousYear: `${a - 1}-${String(end - 1).slice(-2)}`,
        };
  }

  return { currentYear: raw, previousYear: "" };
};
